import { createCollection } from '@tanstack/db';
import { queryCollectionOptions } from '@tanstack/query-db-collection';

import { getDynLabel } from '@/api/generated/digiVAPI';
import { queryClient } from '@/services/queryClient';

export const labelCollection = createCollection(
  queryCollectionOptions({
    id: 'label-collection',
    queryClient,
    queryKey: ['label-collection'],
    getKey: (item) => item.ID,
    queryFn: async () => {
      const response = await getDynLabel({
        page: 1,
        size: 1000,
        sort: [
          {
            field: 'Label',
            direction: 'asc',
          },
        ],
      });

      return response.objects ?? [];
    },
  })
);
